import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import UnderscoreTabbedContent, { UnderscoreTabbedContentProps } from 'components/ui/tabbedContent/UnderscoreTabbedContent/UnderscoreTabbedContent'

import s from './Tabs.scss'


export type TabsProps = {
  tabs: UnderscoreTabbedContentProps['tabs']
  activeTab: number | string
  uppercase?: boolean
  withMobileCompensator?: boolean
  minimalGap?: boolean
  justify?: boolean
  passFullDataToCallback?: boolean
  onTabClick?: (activeTab: string) => void
}

const Tabs: React.FunctionComponent<TabsProps> = (props) => {
  const { tabs, activeTab, uppercase, withMobileCompensator, minimalGap, justify, passFullDataToCallback, onTabClick } = props

  const tabsWithTitleContent = useMemo(() => (
    tabs.map(({ title, ...tab }) => ({
      ...tab,
      titleContent: (
        <Box mb={4} ph={20}>
          <Text
            message={title}
            size="16-24"
            inheritWeight
            uppercase={uppercase}
          />
        </Box>
      ),
    }))
  ), [ tabs, uppercase ])

  const composedTabContainerClassName = cx({
    [s.tabContainer]: !minimalGap,
    [s.justifyTabContainer]: justify,
  })

  const composedTabsClassName = cx({
    [s.justifyTabsContainer]: justify,
  })

  const composedTabsContainerClassName = cx({
    [s.compensator]: withMobileCompensator,
  })

  return (
    <UnderscoreTabbedContent
      tabs={tabsWithTitleContent}
      contentClassName={s.content}
      tabsClassName={composedTabsClassName}
      tabContainerClassName={composedTabContainerClassName}
      tabsContainerClassName={composedTabsContainerClassName}
      defaultActiveTabId={activeTab}
      activeTabId={activeTab}
      onTabClick={onTabClick}
      passFullDataToCallback={passFullDataToCallback}
      uppercase={false}
    />
  )
}


export default Tabs
